import Template from 'Components/Templates/Template';
import { ADMINTAB, ASSISTANTADMINTAB, MOBILEADMINTAB, adminAnalyticsPanelItems, adminCasesPanelItems } from 'Constants';
import React, { useContext, useEffect, useState } from 'react'
import AnalyticsPanelRedirect from './AnalyticsPanelRedirect';
import { Context } from 'Context/Context';
import { useNavigate } from 'react-router-dom';
import Header from 'Components/Header/Header';
import useIsMobile from 'Hooks/useIsMobile';


function AnalyticsLanding() {
  const [activePanel, setActivePanel] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const isMobile = useIsMobile();
  const {userDetails} = useContext(Context);
  let tabElements = isMobile ? MOBILEADMINTAB : ADMINTAB;
  const navigate = useNavigate();
  
  useEffect(()=>{
    if(userDetails?.awaits?.validUserIdCount)
    {
      // the approvals tab isn't at the same position in the phone menu
      const approve = tabElements.find((t) => t.menuName === "approve");
      if (approve) approve.count = userDetails?.awaits?.validUserIdCount;
    }
    if(userDetails.isAdminAssistant)
    {
      navigate("/admin/approve");
    }
  },[])
    return (
      <>
        <Header/>  
        <Template
        activeTab = {activeTab}
        setActiveTab = {setActiveTab}
        tabs= {tabElements}
        leaveTabs={true}
        leaveLeftPanel={isMobile ? true : false}
        panelItems={adminAnalyticsPanelItems}
        activePanel={activePanel}
        setActivePanel={setActivePanel}
        content = {
        !userDetails?.isAdminAssistant &&
        <AnalyticsPanelRedirect activePanel={activePanel} setActivePanel={setActivePanel}/>}
        />
     </>
    )
}

export default AnalyticsLanding
